export const chat_en = {
  'send_suggestion_button_alert' : 'Send walk suggestion to ',
  'send_suggestion_header_alert' : 'Upgrade your account',
  'send_suggestion_message_alert' : 'To be able to send a walk suggestion - upgrade your account to Walking Talking PRO',
  'send_suggestion_linktext_alert' : 'Upgrade',
  'could_not_load_messages' : 'Could not load messages',
  'could_not_send_message' : 'Could not send the message',
  'sent_a_suggestion' : 'Walk suggestion',
  'could_not_find_message' : 'Could not find this message',
  'chat_messages' : 'Messages',
  'our_walks' : 'Our walks',
  'blocked_person' : 'The person is blocked',
  'send_walk_suggestion' : 'Send walk suggestion',
  'send_suggestion' : 'Send suggestion',

  'from_you' : 'You',
  'walk_was_removed' : 'The walk has been deleted',
  'deleted' : 'Deleted',
  'you_accepted_time' : 'You have accepted the suggestion',
  'you_denied_time' : 'You have denied the suggestion',
  'waiting_on_response' : 'Waiting on a response',
  'other_accepted' : 'The walk was accepted',
  'other_deny' : 'The walk was declined',
  'go_to_walk' : 'Go to the walk',

  'you_have_cancelled_walk' : 'The walk was cancelled',
  'they_have_cancelled_walk' : 'The walk was cancelled',
  'has_booked_walk': 'The walk was booked',

  'upcoming' : 'Upcoming',
  'previous' : 'Previous',

  'error_could_not_load' : 'Could not load chat',
  'error_not_allowed_chat' : 'To be able to talk to the person you need to be friends or have a booked walk.',

  'sent_an_invite' : 'Walk invite',

  'walkInfo_today' : 'Walk today: ',
  'walkInfo_tomorrow': 'Walk tomorrow: ',
  'walkInfo_twodays' : 'Walk the day after tomorrow',
  'walkInfo_in_days' : 'Walk in ',
  'walkInfo_day' : ' day/s',
  'walkInfo_latest' : 'Latest walk: '

}